import * as React from "react";
import { CitiTripleDipSectionEditorial } from "./CititripledipSectionEditorial";
import EditorialBase from "../../EditorialBase";
import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import { CitiDesktopStickyBar } from "./CitiDesktopStickybar";

export class Grid3 extends EditorialBase {
  /* istanbul ignore next */
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const { model } = props.flexComponent;
    const stickyBarText = "Sticky_bar";

    return (
      <>
        {model.title.includes("triple_dip_section") && (
          <CitiTripleDipSectionEditorial
            flexComponent={props.flexComponent}
            l10n={props.l10n}
            context={props.context}
          />
        )}

        {model.title.includes(stickyBarText) && (
          <CitiDesktopStickyBar flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
        )}
      </>
    );
  }
}

export default Grid3;
